import React, { useEffect, useRef, useState } from "react";
import { FiAtSign } from "react-icons/fi";
import { AccountModalBody, AccountModalFooter, AccountModalHeader } from "./AccountModalParts";
import { UpdateUsername } from "./Account.api";
import { useAuth } from "context/auth-context";
import { useQueryClient, useMutation } from "@tanstack/react-query";
import { toastrError, toastrSuccess } from "lib/toastr";
import { useTranslation } from "react-i18next";

interface AccountToggleProps {
  username: string;
  isPopupOpen;
}

const AccountToggle: React.FC<AccountToggleProps> = ({ username, isPopupOpen }) => {
  const { auth } = useAuth();
  const { t } = useTranslation();
  const modelRef = useRef();
  const [user_nicename, setuser_nicename] = useState("");
  const [issubmit, setissubmit] = useState(false);
  const [error, setError] = useState("");
  const queryClient = useQueryClient();
  const mutation = useMutation(() => UpdateUsername(auth?.panelistId, user_nicename), {
    onSuccess: (response: any) => {
      if (response.success) {
        toastrSuccess(t("accountTogel.success"));
        queryClient.invalidateQueries(["getAccountDetailsapi"]);
      } else {
        toastrError(t("accountTogel.failed"));
      }
    },
    onError: () => {
      toastrError(t("accountTogel.terminate"));
    },
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    setissubmit(true);

    const usernameRegex = /^[a-zA-Z\s]+$/;

    if (!user_nicename.trim()) {
      setError(t("accountTogel.error.empty"));
    } else if (user_nicename.trim() === username) {
      setError(t("accountTogel.error.same"));
    } else if (!usernameRegex.test(user_nicename.trim())) {
      setError(t("accountTogel.error.special"));
    } else {
      mutation.mutate();
      setError("");
      isPopupOpen();
    }
  };


  

  localStorage.setItem("UserName", JSON.stringify(user_nicename));
  const CloseModal = (e) => {
    if (modelRef.current === e.target) {
      isPopupOpen();
    }
  };


  useEffect(() => {
    if(issubmit){
    if (user_nicename && !user_nicename.trim()) {
      setError(t("accountTogel.error.empty"));
    } else if (user_nicename.trim() === username) {
      setError(t("accountTogel.error.same"));
    } else if (!/^[a-zA-Z\s]+$/.test(user_nicename.trim())) {
      setError(t("accountTogel.error.special"));
    } else {
      setError("");
    }
  }
  }, [user_nicename, username, t]);

  return (
    <>
      {isPopupOpen && (
        <div
          className="zs-backdrop"
          ref={modelRef}
          onClick={CloseModal}
          role="dialog"
          aria-modal="true"
          aria-labelledby="account-username-title"
        >
          <div className="zs-modal max-w-md">
            <AccountModalHeader
              titleId="account-username-title"
              title={t("accountTogel.head")}
              icon={<FiAtSign />}
              onClose={isPopupOpen}
            />

            <AccountModalBody>
              <div>
                <label className="zs-label">{t("accountTogel.current_name")}</label>
                <input type="text" className="zs-input bg-surface-2 text-ink-3" value={username} />
              </div>
              <div>
                <label className="zs-label">{t("accountTogel.new_name")}</label>
                <input
                  type="text"
                  className={`zs-input ${error ? "is-invalid" : ""}`}
                  onChange={(e) => setuser_nicename(e.target.value)}
                />
                {error && <p className="zs-error">{error}</p>}
              </div>
            </AccountModalBody>
            <AccountModalFooter>
              <button className="zs-btn zs-btn-primary" onClick={handleSubmit}>
                {t("accountTogel.button")}
              </button>
            </AccountModalFooter>
          </div>
        </div>
      )}
    </>
  );
};

export default AccountToggle;